{ "bip122:000000000019d6689c085ae165831e93/slip44:0": "bitcoin" }
